import Grid from "@mui/material/Grid";
import DataField from "../../atoms/dataField";
import { FC, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { CONNECTION_TYPES } from "../../../constants/_pickerValues";
import { IFormField } from "../../shared/globalTypes";
import ConnectionWindowsFileshare from "./ConnectionWindowsFileshare";

interface Props {
  selectedConnection: string,
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  endpoint: IFormField,
  database: IFormField,
  extractSource: IFormField,
  port: IFormField,
  instanceName: IFormField,
  username: IFormField,
  password: IFormField,
  serviceName: IFormField,
}

const ConnectionDatabase: FC<Props> = ({ selectedConnection, onChange, endpoint, database, extractSource, port, instanceName,
  username, password, serviceName }: Props) => {

  const [visible, setVisible] = useState(false);
  const [displayExtract, setDisplayExtract] = useState(false);
  const [displayDatabase, setDisplayDatabase] = useState(false);
  const [displayService, setDisplayService] = useState(false);
  const [displayInstance, setDisplayInstance] = useState(false);
  const [displayPort, setDisplayPort] = useState(false);
  const [displayPassword, setDisplayPassword] = useState(false);

  useEffect(() => {
    if (
      selectedConnection === CONNECTION_TYPES.oracle ||
      selectedConnection === CONNECTION_TYPES.postGres ||
      selectedConnection === CONNECTION_TYPES.mssql ||
      selectedConnection === CONNECTION_TYPES.redShift ||
      selectedConnection === CONNECTION_TYPES.lndspoke ||
      selectedConnection === CONNECTION_TYPES.hstgspoke
    ) {
      setVisible(true);

      switch (selectedConnection) {
        case CONNECTION_TYPES.oracle:
          setDisplayExtract(true);
          setDisplayDatabase(true);
          setDisplayService(true);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
        case CONNECTION_TYPES.mssql:
          setDisplayExtract(false);
          setDisplayDatabase(true);
          setDisplayService(false);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
        case CONNECTION_TYPES.redShift:
          setDisplayExtract(false);
          setDisplayDatabase(true);
          setDisplayService(false);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
        case CONNECTION_TYPES.lndspoke:
          setDisplayExtract(false);
          setDisplayDatabase(true);
          setDisplayService(false);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
        case CONNECTION_TYPES.hstgspoke:
          setDisplayExtract(false);
          setDisplayDatabase(true);
          setDisplayService(false);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
        default:
          setDisplayExtract(false);
          setDisplayDatabase(true);
          setDisplayService(false);
          setDisplayInstance(false);
          setDisplayPort(true);
          setDisplayPassword(true);
          break;
      }
    } else {
      setVisible(false);
    }
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box
        sx={{ border: 1, borderColor: "divider", padding: 3, width: "100%" }}
      >
        <h2>
          {selectedConnection === CONNECTION_TYPES.lndspoke
            ? CONNECTION_TYPES.lndspoke
            : selectedConnection === CONNECTION_TYPES.hstgspoke
            ? CONNECTION_TYPES.hstgspoke
            : selectedConnection}
        </h2>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DataField id="d81e7b62-8d0c-4f0c-8527-0ebcbac7adcf"
              label="Endpoint"
              name="endpoint"
              type="text"
              required={true}
              onChange={onChange}
              value={endpoint.fieldValue}
              error={endpoint.isError}
            />
          </Grid>
          {displayDatabase && (
            <Grid item xs={6} sx={{ display: "inline-flex" }}>
              <DataField id="acb3df8c-e727-47bf-8d9f-afe4b24238fc"
                label="Database"
                name="database"
                type="text"
                required={true}
                onChange={onChange}
                value={database.fieldValue}
                error={database.isError}
              />
            </Grid>
          )}
          {displayExtract && (
            <Grid item xs={6} sx={{ display: "inline-flex" }}>
              <DataField id="d49aa8c7-9272-478c-8c17-9fc230eb9be9"
                label="Extract Source"
                name="extractSource"
                type="text"
                required={true}
                onChange={onChange}
                value={extractSource.fieldValue}
                error={extractSource.isError}
              />
            </Grid>
          )}
          {displayPort && (
            <Grid item xs={2}>
              <DataField id="641c0c56-9b60-4d6e-8a42-93512424374a"
                label="Port"
                name="port"
                type="number"
                required={true}
                onChange={onChange}
                value={port.fieldValue}
                error={port.isError}
                infoText="Eg. MSSQL can be 1433, Postgres can be 5432"
              />
            </Grid>
          )}
          {displayInstance && (
            <Grid item xs={4} sx={{ display: "inline-flex" }}>
              <DataField id="85e9401e-40ca-4cb2-8c2d-f9c48ef9720d"
                label="Instance Name"
                name="instanceName"
                type="text"
                // required={true}
                onChange={onChange}
                value={instanceName.fieldValue}
                error={instanceName.isError}
              />
            </Grid>
          )}
          <Grid item xs={4}>
            <DataField id="819ffe22-bedd-4b90-a81f-a52ce05f4caf"
              label="Username"
              name="username"
              type="text"
              required={true}
              onChange={onChange}
              value={username.fieldValue}
              error={username.isError}
            />
          </Grid>
          {displayPassword && <Grid item xs={4}>
            <DataField id="a401fa27-9f3e-4bfb-b068-94c403de7d83"
              label='Password'
              name='password'
              type='password'
              required={true}
              onChange={onChange}
              value={password.fieldValue}
              error={password.isError}
            />
          </Grid>}
          {displayService && <Grid item xs={4} sx={{ display: 'inline-flex' }}>
            <DataField id="95723851-e7b9-4c5a-81e6-0363caafd87c"
              label='Service Name/SID'
              name='serviceName'
              type='text'
              required={true}
              onChange={onChange}
              value={serviceName.fieldValue}
              error={serviceName.isError}
            />
          </Grid>}
        </Grid>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ConnectionDatabase;
